module.exports = __webpack_public_path__ + "img/Skirt-Front-B2-Da-Gd-Ha-Ia.c224043d.png";